// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

import { defineComponent } from 'vue';

export default defineComponent({
    data() {
        return {
            phoneMask: undefined as string | undefined,
        };
    },
    computed: {
        minPhoneLength() {
            if (!this.phoneMask) {
                return 4;
            }
            const indexOfAdditionalInputMask = this.phoneMask.indexOf(
                'nnnnnnnnnnnnnnnnnnnn'
            );
            const countryMaskWithoutExtraChars = this.phoneMask.substring(
                0,
                indexOfAdditionalInputMask - 1
            );

            const result = countryMaskWithoutExtraChars.match(/n/g || []);

            return result?.length;
        },
    },
});
